import { LexemePublishStatus } from '@sayyesschool/common/entities/lexeme';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import { DICTIONARY_PAGE_SIZE, useDictionary } from '@sayyesschool/frontend/features/dictionary';
import { useUser } from '@sayyesschool/frontend/features/user';
import { getWordEnding } from '@sayyesschool/frontend/utils/format';

import Dictionary from '../dictionary';

const initialQuery = {
    publishStatus: LexemePublishStatus.Pending,
    limit: DICTIONARY_PAGE_SIZE
};

export default function DictionaryPage() {
    const [dictionary] = useDictionary(initialQuery);
    const [user] = useUser();

    if (!dictionary) return <LoadingIndicator fullscreen />;

    const { title, numberOfLexemes } = dictionary;
    const description = `${numberOfLexemes} ${getWordEnding('слов', numberOfLexemes, ['о', 'а', ''])}`;

    return (
        <Page layout="narrow">
            <Page.Header
                title={title}
                description={description}
            />

            <Page.Content>
                <Page.Section
                    variant="outlined"
                    compact
                >
                    <Dictionary
                        dictionary={dictionary}
                        user={user}
                    />
                </Page.Section>
            </Page.Content>
        </Page>
    );
}